"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgTipsFilled = function (props) {
    var color = props.color;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20 9.5c0 2.286-1.085 4.29-2.723 5.639l-.147.589a3 3 0 0 1-2.133 2.17L15 18v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-2c0-.034 0-.069.003-.102a3 3 0 0 1-2.133-2.17l-.147-.59C5.085 13.79 4 11.787 4 9.5 4 5.198 7.75 2 12 2s8 3.198 8 7.5ZM11 20v-2h2v2h-2Zm6.625-11.455c0-2.51-2.099-4.545-4.688-4.545-.517 0-.937.407-.937.91 0 .501.42.908.938.908 1.553 0 2.812 1.221 2.812 2.727l.006.106c.054.453.45.804.931.804.518 0 .938-.407.938-.91Z", fill: color }));
};
exports.default = factorySvgIcon_1.default(SvgTipsFilled);
//# sourceMappingURL=SvgTipsFilled.js.map